module.exports = __webpack_public_path__ + "static/media/rules.d5ee4cc9.jpg";